import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/icon.jpeg'


const _hoisted_1 = { class: "w-full font-montserrat relative" }
const _hoisted_2 = { class: "flex justify-center items-center z-30 flex-col fixed top-[70px] left-[50%] w-full translate-x-[-50%]" }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-500 border border-red-500 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-500 border border-red-500 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_5 = {
  key: 2,
  class: "bg-red-500 border border-red-500 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_6 = {
  key: 3,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_7 = {
  key: 4,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_8 = { class: "relative mb-[50px] w-full" }
const _hoisted_9 = { class: "py-[20px] flex flex-col items-center relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] text-center" }, "Home / Profil", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl uppercase font-bold text-center text-black py-[20px]" }, "Profile", -1)
const _hoisted_12 = { class: "block md:flex justify-center w-[90%] py-[10px]" }
const _hoisted_13 = { class: "md:w-[200px] p-[10px] w-full md:h-[200px] bg-white md:mx-[10px] flex flex-col justify-center items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-[120px] h-[120px] rounded-[50%] border border-black"
}, null, -1)
const _hoisted_15 = { class: "uppercase my-[10px]" }
const _hoisted_16 = { class: "w-full md:my-[0px] my-[20px] md:w-[calc(100%-240px)] relative bg-white md:mx-[10px] px-[10px] py-[50px]" }
const _hoisted_17 = { class: "md:py-[40px] md:px-[20px] px-[10px] py-[30px]" }
const _hoisted_18 = ["onSubmit"]
const _hoisted_19 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Ancien mot de passe", -1)
const _hoisted_21 = { class: "relative min-w-[45%] max-w-[50%]" }
const _hoisted_22 = ["type"]
const _hoisted_23 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Nouveau mot de passe", -1)
const _hoisted_25 = { class: "relative min-w-[45%] max-w-[50%]" }
const _hoisted_26 = ["type"]
const _hoisted_27 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Confirmer le nouveau mot de passe", -1)
const _hoisted_29 = { class: "relative min-w-[45%] max-w-[50%]" }
const _hoisted_30 = ["type"]
const _hoisted_31 = { class: "flex py-[15px] items-center justify-center" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import axios from 'axios';
import { ref, onMounted } from 'vue';
import headerComponent from '../components/headerComponentAdmin.vue';
import linkProfile from '../components/linkProfile.vue';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePassword',
  setup(__props) {

const apassword = ref("");
const ashowPassword = ref(false);
const npassword = ref("");
const cpassword = ref("");
const nshowPassword = ref(false);
const cshowPassword = ref(false);
const pageTitle = ref('Profile password');
const errorMessage1 = ref('');
const errorMessage2 = ref('');
const successMessage1 = ref('');
const successMessage = ref('');
const errorMessage = ref('');
const updatedUser = ref({});
const router = useRouter();
const loading = ref(false);

onMounted(() => {
  document.title = pageTitle.value;
  fetchUserProfile();
});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    updatedUser.value = { ...response.data }; 
  } catch (error) {
    console.error(error);
  }
};

const changePassword = async () => {
  try {
    loading.value = true;
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    // Vérification si les nouveaux mots de passe correspondent
    if (npassword.value !== cpassword.value) {
      errorMessage2.value = 'Les nouveaux mots de passe ne correspondent pas.';
        hideErrorMessageAfterDelay();
      return;
    }

    // Vérification de la longueur du nouveau mot de passe
    if (npassword.value.length < 8) {
      errorMessage1.value = 'Le nouveau mot de passe doit contenir au moins 8 caractères.';
        hideErrorMessageAfterDelay();
      return;
    }

    // Vérification du format du nouveau mot de passe (majuscules, minuscules, chiffres, caractères spéciaux)
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(npassword.value)) {
      errorMessage1.value = 'Le nouveau mot de passe doit contenir au moins 8 caractères avec majuscules, minuscules, chiffres et caractères spéciaux.';
        hideErrorMessageAfterDelay();
      return;
    }

    // Appel à l'API pour changer le mot de passe
    const response = await axiosInstance.post('/auth/users/set_password/',
      {
        current_password: apassword.value,
        new_password: npassword.value,
        re_new_password: cpassword.value,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    // On successful password change
    successMessage1.value = 'Mot de passe changé avec succès.';
    successMessage.value = 'Vous serez déconnecté dans 5 secondes.';
    setTimeout(() => {
      localStorage.clear();
      router.push('/log');
    }, 5000);
  } catch (error: any) {
    console.error(error);

    // Handle error messages
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage.value = error.response.data.message;
        hideErrorMessageAfterDelay();
    } else {
      errorMessage.value = "Une erreur est survenue lors du changement de mot de passe.";
        hideErrorMessageAfterDelay();
    }
  } finally {
    loading.value = false;
  }
};
const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
  setTimeout(() => {
    errorMessage1.value = ''; 
  }, 5000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    _createElementVNode("div", _hoisted_2, [
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (errorMessage1.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage1.value), 1))
        : _createCommentVNode("", true),
      (errorMessage2.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errorMessage2.value), 1))
        : _createCommentVNode("", true),
      (successMessage1.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(successMessage1.value), 1))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(successMessage.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("h1", _hoisted_15, _toDisplayString(updatedUser.value.firstname) + " " + _toDisplayString(updatedUser.value.lastname), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(linkProfile),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(changePassword, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: ashowPassword.value ? 'text' : 'password',
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((apassword).value = $event)),
                      placeholder: "Mot de passe",
                      id: "password",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full"
                    }, null, 8, _hoisted_22), [
                      [_vModelDynamic, apassword.value]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["password-toggle", ashowPassword.value ? 'fa fa-eye text-sm absolute top-[10px] right-[10px]' : 'fa fa-eye-slash text-sm absolute top-[10px] right-[10px]']),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (ashowPassword.value = !ashowPassword.value))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: nshowPassword.value ? 'text' : 'password',
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((npassword).value = $event)),
                      placeholder: "Mot de passe",
                      id: "password",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full"
                    }, null, 8, _hoisted_26), [
                      [_vModelDynamic, npassword.value]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["password-toggle", nshowPassword.value ? 'fa fa-eye text-sm absolute top-[10px] right-[10px]' : 'fa fa-eye-slash text-sm absolute top-[10px] right-[10px]']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (nshowPassword.value = !nshowPassword.value))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: cshowPassword.value ? 'text' : 'password',
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cpassword).value = $event)),
                      placeholder: "Mot de passe",
                      id: "password",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full"
                    }, null, 8, _hoisted_30), [
                      [_vModelDynamic, cpassword.value]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["password-toggle", cshowPassword.value ? 'fa fa-eye text-sm absolute top-[10px] right-[10px]' : 'fa fa-eye-slash text-sm absolute top-[10px] right-[10px]']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (cshowPassword.value = !cshowPassword.value))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: loading.value,
                    class: "uppercase cursor-pointer font-bold bg-cyan-500 text-white outline-none rounded-[5px] py-[5px] px-[30px] w-auto"
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                      : (_openBlock(), _createElementBlock("span", _hoisted_34, "Save"))
                  ], 8, _hoisted_32)
                ])
              ], 40, _hoisted_18)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_35
  ]))
}
}

})